import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ProfileView from '../views/ProfileView.vue'
import ProjectDetailView from '../views/ProjectDetailView.vue'
import SkillDetailView from '../views/SkillDetailView.vue'
import SkillsView from '../views/SkillsView.vue'
import ProjectsView from '../views/ProjectsView.vue'
import ProjectNewView from '../views/ProjectNewView.vue'
import EnrollVeiw from '../views/EnrollView.vue'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[Home',
      },
      component: HomeView,
    },

    {
      path: '/projects',
      name: 'projects',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[Projects',
      },
      component: ProjectsView,
    },

    {
      path: '/new',
      name: 'new',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[New',
      },
      component: ProjectNewView,
    },

    {
      path: '/project/:id',
      name: 'project-detail',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[Project Detail'
      },
      component: ProjectDetailView,
    },

    {
      path: '/skills',
      name: 'skills',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[Skills'
      },
      component: SkillsView,
    },

    {
      path: '/skill/:id',
      name: 'skill-detail',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[Skill Detail'
      },
      component:SkillDetailView,
    },

    {
      path: '/enroll',
      name: 'enroll',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[Enroll',
      },
      component: EnrollVeiw,
    },

    {
      path: '/login',
      name: 'login',
      meta: {
        title: 'Portfolio[Login',
      },
      component: LoginView,
    },

    {
      path: '/profile',
      name: 'profile',
      meta: {
        requiresAuth: true,
        title: 'Portfolio[Profile',
      },
      component: ProfileView,
    },

    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFoundView.vue'),
    },
  ],
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Portfolio'
  next()
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const isAuthenticated = await authStore.checkAuth()

  // Pokud route vyžaduje auth a uživatel není přihlášený
  if (to.meta.requiresAuth && !isAuthenticated) {
    // Uložíme původní cíl
    return next({
      name: 'login',
      query: { redirect: to.fullPath },
    })
  }
  // Pokud je přihlášený a jde na login, pošleme ho na home
  if (isAuthenticated && to.name === 'login') {
    return next({ name: 'home' })
  }

  next()
})

export default router
